import { Attr, HasMany, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsReport from "./InsightsReport";
import type Organisation from "./Organisation";

@Model()
class InsightsReportGroup extends ApplicationRecord {
  static jsonapiType = "insights_report_groups";

  @Attr() archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() favorite: boolean;

  @HasMany() insightsReports: InsightsReport[];

  @Attr() label: string;

  @HasOne() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() reportType: string;
}

export default InsightsReportGroup;
